import { api } from "@/lib/api";

import type {
  CancelTransformationReq,
  CompleteProductionReq,
  CreateProductionReq,
  CreateRepackReq,
  GetRepackShrinkageReq,
  GetTransformationListReq,
  ProductionPrefillRes,
  RepackShrinkageReportRes,
  StockTransformation,
  TransformationListRes,
} from "@artisancode/api-types";

export const stockTransformationService = {
  list: (params?: GetTransformationListReq) =>
    api.get<TransformationListRes>(
      "/stock-transformations",
      params as unknown as Record<
        string,
        string | number | boolean | undefined
      >,
    ),

  getRepackShrinkage: (params: GetRepackShrinkageReq) =>
    api.get<RepackShrinkageReportRes>(
      "/stock-transformations/repack-shrinkage",
      {
        start_date: params.startDate,
        end_date: params.endDate,
        raw_material_id: params.rawMaterialId,
      },
    ),

  detail: (id: string, params?: { workspace_id?: string }) =>
    api.get<StockTransformation>(
      `/stock-transformations/${id}`,
      params as Record<string, string | number | boolean | undefined>,
    ),

  createRepack: (body: CreateRepackReq, idempotencyKey?: string) =>
    api.post<StockTransformation>(
      "/stock-transformations/repack",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  prefillProduction: (params: {
    product_id: string;
    yield?: number;
    workspace_id?: string;
  }) =>
    api.get<ProductionPrefillRes>(
      "/stock-transformations/production/prefill",
      params as Record<string, string | number | boolean | undefined>,
    ),

  createProduction: (body: CreateProductionReq, idempotencyKey?: string) =>
    api.post<StockTransformation>(
      "/stock-transformations/production",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  complete: (id: string, body?: CompleteProductionReq) =>
    api.post<StockTransformation>(
      `/stock-transformations/${id}/complete`,
      body,
    ),

  cancel: (id: string, body: CancelTransformationReq) =>
    api.post<StockTransformation>(`/stock-transformations/${id}/cancel`, body),
};
